<template>
  <v-container
      fluid>

    <div>

<div
    v-if="export_csv"
>
      <vue-json-to-csv
          csv-title="Export"
          :json-data="data">
        <v-btn
            fab
            style="
    position: absolute;
    top: 5px;
    right: 5px;
"
        ><v-icon>mdi-microsoft-excel</v-icon></v-btn>
      </vue-json-to-csv>
</div>

      <!-- :custom-sort="customSort" -->

      <v-data-table

          :height="height"
          :headers="headers"
          :items="data"
          :key="key"
          item-key="id"
          :items-per-page="100"
          class="elevation-7"
          :search="search"
          :custom-filter="filterOnlyCapsText"
          :custom-sort="customSort"



          :footer-props="{
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
           'items-per-page-options': [50, 100, 200, -1],
           'items-per-page-text':'pro Seite'
      }"


      >
      <template v-if="table === 'cis_task'" v-slot:item="{ item }">
        <tr :class="getRowClass(item.status)">
          <td v-for="header in headers" :key="header.value">


            <template v-if="header.value === 'date'">
              {{ $moment(item.date, "YYYY-MM-DD").format("DD.MM.YYYY") }}
            </template>
            <template v-else-if="header.value === 'execution_date'">
              {{ $moment(item.execution_date, "YYYY-MM-DD").format("DD.MM.YYYY") }}
            </template>
 
       
            <template v-else-if="header.value === 'edit'">
              <v-row>
                <div style="display: inline; white-space: nowrap;">
                  <v-icon style="padding: 3px;" color="red" @click="showDeleteDialog(item.id, item.company)">mdi-delete-outline</v-icon>
                  <v-icon style="padding: 3px;" @click="editEntry(item.id)">mdi-pencil-outline</v-icon>
                </div>
              </v-row>
            </template>
            <template v-else>
              {{ item[header.value] }}
            </template>
          </td>
        </tr>
      </template>

      <template v-else-if="table === 'cis_complaint'" v-slot:item="{ item }">
        <tr :class="getComplaintRowClass(item.completed)">
          <td v-for="header in headers" :key="header.value">
            <template v-if="header.value === 'completed'">
              <v-icon :color="item.completed == 1 ? 'green' : 'red'">
                {{ item.completed == 1 ? 'mdi-check-circle' : 'mdi-close-circle' }}
              </v-icon>
            </template>
            <template v-else-if="header.value === 'edit'">
              <v-row>
                <div style="display: inline; white-space: nowrap;">
                  <v-icon style="padding: 3px;" color="red" @click="showDeleteDialog(item.id, item.company)">mdi-delete-outline</v-icon>
                  <v-icon style="padding: 3px;" @click="editEntry(item.id)">mdi-pencil-outline</v-icon>
                </div>
              </v-row>
            </template>
            <template v-else>
              {{ item[header.value] }}
            </template>
          </td>
        </tr>
      </template>

   

   

        <template v-slot:item.date="{item}">
          
           
          <p v-if="item.worker_add != 'AUTO'" style="">{{ item.date }}</p>
          <p v-if="item.worker_add == 'AUTO'" style="background-color: #e91e63">{{ item.date}}</p>
     
        </template>

        <template v-slot:item.note="{item}">

          <p class="tooltip">{{ item.note.toString().substring(0, 15) }}
            <span class="tooltiptext">{{ item.note.toString() }}</span>
          </p>

        </template>



        <template v-slot:item.parking_address="{item}">

          <div v-if="item.parking_address != null">
          <p class="tooltip">{{ item.parking_address.toString().substring(0,15) }}
            <span class="tooltiptext">{{ item.parking_address.toString() }}</span>
          </p>
          </div>

        </template>



        <template v-slot:item.date_timestamp="{item}">

          <div v-if='$moment(item.date_timestamp, "YYYY-MM-DD").format("DD.MM.YYYY") != "Invalid date"'>
            <div v-if="item.worker_add != 'AUTO'" style="">{{ $moment(item.date_timestamp, "YYYY-MM-DD").format("DD.MM.YYYY") }}</div>
            <div v-if="item.worker_add == 'AUTO'" style="background-color: #e91e63"> {{ $moment(item.date_timestamp, "YYYY-MM-DD").format("DD.MM.YYYY") }}</div>
          </div>
          <div v-else>
            <div v-if="item.worker_add != 'AUTO'" style="">{{ item.date }}</div>
            <div v-if="item.worker_add == 'AUTO'" style="background-color: #e91e63">{{ item.date }}</div>
          </div>

        </template>


        <template v-slot:item.weight_qty="{item}">
          <p>{{item.weight}} / {{item.weight_type}}</p>
        </template>


        <template v-slot:item.execution_date="{item}">
          <div>{{ item.execution_date }}</div>
        </template>


        <template v-slot:item.pickup_timestamp="{item}">

          <div v-if='$moment(item.pickup_timestamp, "YYYY-MM-DD").format("DD.MM.YYYY") != "Invalid date"'>
            {{ $moment(item.pickup_timestamp, "YYYY-MM-DD").format("DD.MM.YYYY") }}
          </div>
          <div v-else>{{ item.pickup_date }}</div>

        </template>


        <template v-slot:item.complaint_date_timestamp="{item}">
          <div v-if='$moment(item.complaint_date_timestamp, "YYYY-MM-DD").format("DD.MM.YYYY") == "Invalid date" || $moment(item.complaint_date_timestamp, "YYYY-MM-DD").format("DD.MM.YYYY") == "0000-00-00"'>

          </div>
          <div v-else>{{ $moment(item.complaint_date_timestamp, "YYYY-MM-DD").format("DD.MM.YYYY") }}</div>
        </template>



        <template v-slot:item.weight="{item}">

          <p style="color: green" v-if="Number(item.weight) >= 0">{{ item.weight }}</p>
          <p style="color: red" v-else>{{ item.weight }}</p>

        </template>

        <template v-slot:item.onlysprinter="{item}">

          <p style="color: green" v-if="item.onlysprinter == 'true'">
             <v-icon color="red" style="margin-top: 5px;">mdi-car-estate</v-icon>
          </p>
          <p style="color: red" v-else></p>

        </template>


        <template v-slot:item.invoice_forward="{item}">

          <p style="color: green" v-if="item.invoice_forward == 1 && item.invoice_forward_written != ''"><v-icon color="green" style="margin-top: 5px;">mdi-check-circle</v-icon></p>
          <p style="color: red" v-if="item.invoice_forward == 1 && item.invoice_forward_written == ''"><v-icon color="red" style="margin-top: 5px;">mdi-close-circle</v-icon></p>

        </template>




        <template v-slot:item.invoice_incoming="{item}">

          <p style="color: green" v-if="item.invoice_incoming == 1"><v-icon color="green" style="margin-top: 5px;">mdi-check-circle</v-icon></p>
          <p style="color: red" v-else><v-icon color="red" style="margin-top: 5px;">mdi-close-circle</v-icon></p>

        </template>


        <template v-slot:item.invoice_outgoing="{item}">

          <p style="color: green" v-if="item.invoice_outgoing == 1"><v-icon color="green" style="margin-top: 5px;">mdi-check-circle</v-icon></p>
          <p style="color: red" v-else><v-icon color="red" style="margin-top: 5px;">mdi-close-circle</v-icon></p>

        </template>





        <template v-slot:item.invoice="{item}">

          <p style="color: green" v-if="item.invoice == 1"><v-icon color="green" style="margin-top: 5px;">mdi-check-circle</v-icon></p>
          <p style="color: red" v-else><v-icon color="red" style="margin-top: 5px;">mdi-close-circle</v-icon></p>

        </template>



        <template v-slot:item.invoice_payment_date="{item}">

          <p style="color: green" v-if="item.invoice_payment_date != ''"><v-icon color="green" style="margin-top: 5px;">mdi-check-circle</v-icon></p>
          <p style="color: red" v-else><v-icon color="red" style="margin-top: 5px;">mdi-close-circle</v-icon></p>

        </template>



        <template v-slot:item.typ="{item}">

          <p style="color: green" v-if="item.typ == 'buy'">Eingang</p>
          <p style="color: red" v-if="item.typ == 'sell'">Verkauf</p>
          <p style="color: red" v-if="item.typ == 'disposal'">Verschrottung</p>

        </template>



        <template v-slot:item.prio="{item}">

          <p style="color: green" v-if="item.prio == 1">&blk34;</p>
          <p style="color: orange" v-if="item.prio == 2">&blk34;</p>
          <p style="color: red" v-if="item.prio == 3">&blk34;</p>

        </template>



        <template v-slot:item.date_convert="{item}">

          {{ $moment(item.date, "YYYY-MM-DD").format("DD.MM.YYYY") }}

        </template>


  <template v-slot:item.rating="{item}">
  <v-row>
    <div style="display: inline-block; white-space: nowrap;">
      <div style="display: inline-block;">
        
        <template v-if="item.rating && item.rating !== '???'">
          <v-icon v-if="Math.round(Number(item.rating)) == 1" color="red" style="padding: 3px;">mdi-star</v-icon>
          <v-icon v-else-if="Math.round(Number(item.rating)) == 2" color="orange" style="padding: 3px;">mdi-star</v-icon>
          <v-icon v-else-if="Math.round(Number(item.rating)) == 3" color="yellow" style="padding: 3px;">mdi-star</v-icon>
          <v-icon v-else-if="Math.round(Number(item.rating)) == 4" color="lime" style="padding: 3px;">mdi-star</v-icon>
          <v-icon v-else-if="Math.round(Number(item.rating)) == 5" color="green" style="padding: 3px;">mdi-star</v-icon>
        </template>
        <!-- Show empty star for no rating -->
        <v-icon v-else color="grey" style="padding: 3px;">mdi-star-outline</v-icon>
      </div>

      <!-- Display percentage if rating exists -->
      <div style="display: inline-block;" v-if="item.rating && item.rating !== '???' && item.rating_in_percent">
        {{ item.rating_in_percent }}%
      </div>
      <div style="display: inline-block;" v-else>--%</div>
    </div>
  </v-row>
   <!--
          <v-hover v-slot:default="{ hover }">
            <v-badge id="badge" :class="{'on-hover':hover}" color="deep-purple accent-4" content="Second Button" left transition="slide-x-transition">
            </v-badge>
          </v-hover>
          -->
</template>



        <template v-slot:item.delete="{item}">

          <v-row>
            <div
                style="
              display: inline;
              white-space: nowrap;"
            >
              <v-icon style="padding: 3px;" color="red" @click="showDeleteDialog(item.id, item.company)">mdi-delete-outline</v-icon>

            </div>

          </v-row>
          <!--
          <v-hover v-slot:default="{ hover }">
            <v-badge id="badge" :class="{'on-hover':hover}" color="deep-purple accent-4" content="Second Button" left transition="slide-x-transition">
            </v-badge>
          </v-hover>
          -->
        </template>



        <template v-slot:item.edit="{item}">

          <v-row>
            <div
                style="
              display: inline;
              white-space: nowrap;"
            >
          <v-icon style="padding: 3px;" color="red" @click="showDeleteDialog(item.id, item.company)">mdi-delete-outline</v-icon>

          <v-icon style="padding: 3px;" @click="editEntry(item.id)">mdi-pencil-outline</v-icon> <!--{{item.calories}}-->
            </div>

          </v-row>
          <!--
          <v-hover v-slot:default="{ hover }">
            <v-badge id="badge" :class="{'on-hover':hover}" color="deep-purple accent-4" content="Second Button" left transition="slide-x-transition">
            </v-badge>
          </v-hover>
          -->
        </template>





        <template v-slot:item.price="{item}">

          <p style="color: green" v-if="Number(item.price) >= 0">{{ item.price }}</p>
          <p style="color: red" v-else>{{ item.price }}</p>

        </template>







        <template v-slot:item.select ="{item}">

          <v-row>
            <div
                style="
              display: inline;
              white-space: nowrap;"
            >
              <v-icon color="pink" @click="selectEntry(item.id)">mdi-checkbox-marked-outline</v-icon>
            </div>

          </v-row>
          <!--
          <v-hover v-slot:default="{ hover }">
            <v-badge id="badge" :class="{'on-hover':hover}" color="deep-purple accent-4" content="Second Button" left transition="slide-x-transition">
            </v-badge>
          </v-hover>
          -->
        </template>






        <template v-slot:item.select_add="{item}">

          <v-row>
            <div
                style="
              display: inline;
              white-space: nowrap;"
            >
               <v-icon color="pink" style="padding: 3px;" @click="emitAddToTour(item.id)">mdi-plus-box</v-icon> <!--{{item.calories}}-->
            </div>

          </v-row>
          <!--
          <v-hover v-slot:default="{ hover }">
            <v-badge id="badge" :class="{'on-hover':hover}" color="deep-purple accent-4" content="Second Button" left transition="slide-x-transition">
            </v-badge>
          </v-hover>
          -->
        </template>




        <template v-slot:item.select_delete="{item}">

          <v-row>
            <div
                style="
              display: inline;
              white-space: nowrap;"
            >

              <v-icon color="gray" style="padding: 3px;" @click="posUp(item.id)">mdi-arrow-up-drop-circle</v-icon> <!--{{item.calories}}-->
              <v-icon color="gray" style="padding: 3px;" @click="posDown(item.id)">mdi-arrow-down-drop-circle</v-icon> <!--{{item.calories}}-->


              <v-icon color="#383083" style="padding: 3px;" @click="delete2Tour(item.id)">mdi-minus-box</v-icon> <!--{{item.calories}}-->


            </div>

          </v-row>
          <!--
          <v-hover v-slot:default="{ hover }">
            <v-badge id="badge" :class="{'on-hover':hover}" color="deep-purple accent-4" content="Second Button" left transition="slide-x-transition">
            </v-badge>
          </v-hover>
          -->
        </template>







<template v-slot:top>
  <v-text-field
    v-model="search"
    label="Filter"
    clearable
    class="mx-4"
    @click:clear="handleSearchClear"
    @input="handleSearchInput"
    @change="handleSearchInput"
  ></v-text-field>

  <div v-if="filter_clearing == true" style="margin-left: 30px;">
    <v-row align="center" no-gutters>
      
      <v-col cols="auto" class="pr-2">
        <v-switch
          v-model="switch_clearing"
          label="Nicht abgerechnete Aufträge anzeigen"
          class="mt-0 pt-0"
          hide-details
        ></v-switch>
      </v-col>
      
      
       <template v-if="table === 'task'">
        <v-col cols="6" sm="2" md="3" class="pr-2 pf-8">
          <v-select
            v-model="selected_group_type"
            :items="groups"
            item-text="name"
            item-value="id"
            label="Untergruppe"
            clearable
            dense
            outlined
            multiple
            chips
            small-chips
            deletable-chips
            hide-details
          ></v-select>
        </v-col>
        
        <v-col cols="auto">
          <v-btn
            color="#383083"
            dark
            small
            @click="openInvoiceDialog"
            class="ml-2"
          >
            Rechnung erstellen
          </v-btn>
        </v-col>
      </template>
    </v-row>
  </div>
</template>


      </v-data-table>
        <InvoiceDialog
      v-model="showInvoiceDialog"
      :initial-data="invoiceDialogData"
       :selected-group-types="selected_group_type"
        :group-list="groups"
      @item-updated="handleItemUpdated"
      @edit-item="handleEditItem"
      @item-deleted="handleItemDeleted"
      @save-changes="handleSaveChanges"
      @export-data="handleExportData"
      @close="handleDialogClose"
     @show-snackbar="showSnackbar"
    />

    </div>

    <!--
    LÖSCHEN DIALOG
    -->

    <v-row justify="center">
      <v-dialog
          v-model="dialog"
          persistent
          max-width="600px"
      >

<!--
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
          >
            Open Dialog
          </v-btn>
        </template>
-->



        <v-card>
          <v-card-title>
            <span class="text-h5">Wirklich Löschen</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                      Wollen Sie den Datensatz&nbsp;<b>{{dialog_text}}</b>&nbsp;wirklich löschen?
              </v-row>

              <v-text-field
                  v-model="dialog_password"
              type="password"
              placeholder="Passwort"
              ></v-text-field>

            </v-container>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn

                text
                @click="dialog = false"
            >
              Abbrechen
            </v-btn>
            <v-btn
                color="red"
                text
                @click="deleteEntry"
            >
              Löschen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>





    <v-fab-transition>
      <v-btn
          v-if='addbutton == true'
          color="pink"
          dark
          fixed
          bottom
          right
          fab
          @click="openAddView"

      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>




    <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbar_color"

    >
      {{ snackbar_title }}
      <!--
            <template v-slot:action="{ attrs }">
              <v-btn
                  color="white"
                  text
                  v-bind="attrs"
                  @click="snackbar = false"
              >
                Close
              </v-btn>
            </template>
       -->

    </v-snackbar>



  </v-container>
</template>

<script>
import Vue from "vue";
import VueJsonToCsv from 'vue-json-to-csv'
import InvoiceDialog from '@/components/InvoiceDialog'
import { useActivityLog } from '@/composables/useActivityLog'

export default {
  name: "ListDefault",

  components:{
    VueJsonToCsv,

    InvoiceDialog
  },

  data () {
    return {

      key: 0,

      data: [],
      dialog: false,

      search: '',
      sort: '',
      limit: '',

      rating1: "0",
      rating2: "0",
      rating3: "0",
      rating4: "0",
      rating5: "0",

      dialog_id: '',
      dialog_text: '',
      dialog_password: '',

      switch_clearing: false,

      snackbar: false,
      snackbar_title: 'Gespeichert!',
      snackbar_color: 'red',
      timeout: 4000,

   groups: [],
    selected_group_type: null,
    showGroupTypeDialog: false,
       showInvoiceDialog: false,
      invoiceDialogData: [],

      isUpdatingProgrammatically: false
    }

  },


  created() {
    // Initialize selected_group_type from localStorage FIRST
    const savedGroupType = localStorage.getItem(this.getGroupTypeStorageKey());
    if (savedGroupType) {
      try {
        this.selected_group_type = JSON.parse(savedGroupType);
        console.log("Restored selected_group_type from localStorage:", this.selected_group_type);
      } catch (e) {
        console.error('Error parsing saved group type:', e);
        this.selected_group_type = null;
      }
    }

    this.getRatingValues()
    
    // Initialize search from localStorage
    const savedSearch = localStorage.getItem(this.getStorageKey());
    if (savedSearch && savedSearch.trim() !== '') {
      this.search = savedSearch;
    }

    this.filterLoadData(this.search)

  },



  mounted() {
  
    this.loadGroupTypes();
  },

 watch: {

search(newValue, oldValue) {
    if (this.isUpdatingProgrammatically) {
      console.log("-- skipping watcher during programmatic update --");
      return;
    }
    
    if (newValue !== oldValue) {
      console.log("-- new value --:", newValue);

      if (newValue && newValue.trim() !== '') {


        localStorage.setItem(this.getStorageKey(), newValue);
      } else {
        localStorage.removeItem(this.getStorageKey());
      }
      this.$nextTick(() => {
        if (this.switch_clearing) {
          this.showNotClearedEntrys(newValue);
        } else {
          this.filterLoadData(newValue);
        }
      });
    }
  },

switch_clearing(newValue) {
    console.log("Toggle switch:", newValue);

    this.$emit('filterChange', {
      showNotCleared: newValue,
      customerSearch: this.search
    });

    this.data = [];

    this.$nextTick(() => {
      if (newValue) {
        console.log("Showing not cleared entries");
        this.showNotClearedEntrys(this.search);
      } else {
         console.log("Showing all entries");
      this.filterLoadData(this.search);
      }
    });
  },
  selected_group_type: {
        handler(newValue, oldValue) {
            console.log("Selected group type changed:", newValue, "Old:", oldValue);
            if (newValue && newValue.length > 0) {
              localStorage.setItem(this.getGroupTypeStorageKey(), JSON.stringify(newValue));
            } else {
              localStorage.removeItem(this.getGroupTypeStorageKey());
            }
            
            if (oldValue === undefined && !this.data.length) {
              console.log("Skipping initial watcher call during mount");
              return;
            }
            
            this.$nextTick(() => {
              this.$nextTick(() => {
                console.log("Reloading data with group filter...");
                if (this.switch_clearing) {
                    this.showNotClearedEntrys(this.search || '');
                } else {
                    this.filterLoadData(this.search || '');
                }
              });
            });
        },
        deep: true,
        immediate: false
    }
},


  methods: {

    getGroupTypeStorageKey() {
      return `selectedGroupType_${this.$route.path}`;
    },


    async loadGroupTypes() {
      console.log("Loading group types...");
      const param = {
        table: "group_type",
        statement: "select",
        type: "list",
        where: "",
        selector: "1",
        value: "1",
        short: "false",
        extension: ""
      };

      const data = {};

      try {
        const result = await this.$func.queryAPI(param, data);

        if (Array.isArray(result) && result.length > 0) {
          this.groups = result.map(group => {
            return {
              id: Number(group.id),
              name: group.name || "Unknown Group"
            };
          }).sort((a, b) => a.name.localeCompare(b.name));
          console.log("List groups:", this.groups);
        } else {
          console.warn("No group data found:", result);
          this.groups = [];
        }
      } catch (error) {
        console.error("Error fetching groups:", error);
        this.groups = [];
      }
    },

    handleGroupTypeChange(selectedValue) {
      console.log('Selected group type:', selectedValue);
      if (selectedValue) {
        const selectedGroupType = this.groups.find(gt => gt.value === selectedValue);
        console.log('Selected group type object:', selectedGroupType);
        this.filterByGroupType(selectedValue);
      } else {
        this.clearGroupTypeFilter();
      }
    },

    filterByGroupType(groupTypeId) {
      console.log('Filtering by group type ID:', groupTypeId);
      // Trigger data reload with new filter
      this.filterLoadData(this.search);
    },

    clearGroupTypeFilter() {
      console.log('Clearing group type filter');
      // Trigger data reload without group type filter
      this.filterLoadData(this.search);
    },

    // Add watcher for group type changes
    handleGroupTypeChange() {
      console.log('Group type selection changed:', this.selected_group_type);
      // Optionally reload main data when group type changes
      this.filterLoadData(this.search);
    },

    // Invoice Dialog Methods
    async openInvoiceDialog() {
      console.log("Opening invoice dialog...");
      
      // Check if group types are selected
      // if (!this.selected_group_type || this.selected_group_type.length === 0) {
      //   this.showSnackbar({
      //     message: 'Bitte wählen Sie zuerst einen Group Type aus',
      //     color: 'warning'
      //   });
      //   return;
      // }
      
      // Load filtered data for the dialog
      try {
        await this.loadInvoiceData();
        this.showInvoiceDialog = true;
      } catch (error) {
        console.error("Error loading invoice data:", error);
        this.showSnackbar({
          message: 'Fehler beim Laden der Daten',
          color: 'error'
        });
      }
    },

    async loadInvoiceData() {
      
      let groupTypeFilter = '';
      if (this.selected_group_type && this.selected_group_type.length > 0) {
        const groupTypeIds = this.selected_group_type.join(',');
        groupTypeFilter = ` AND group_type_id IN (${groupTypeIds})`;
      }

      let whereClause = "(invoice IS NULL OR invoice='' OR invoice='0')";
      
      if (this.table == "task") {
       whereClause += " AND (pickup_date IS NOT NULL AND pickup_date<>'')";
      }
    
     
      whereClause += groupTypeFilter;
      

      

      const param = {
        table: "task",
        statement: "custom",
        type: "list",
        where: "false",
        selector: "",
        value: "",
        short: "false",
        extension: `SELECT * FROM task WHERE ${whereClause} ORDER BY pickup_date DESC`
      };

      console.log("Loading invoice data with filter:", whereClause);

      try {
        const result = await this.$func.queryAPI(param, {});
        this.invoiceDialogData = result || [];
        
        console.log(`Loaded ${this.invoiceDialogData.length} filtered records for dialog`);
        
        // If no data found, show message
        if (this.invoiceDialogData.length === 0) {
          this.showSnackbar({
            message: 'Keine Daten für die ausgewählten Filter gefunden',
            color: 'info'
          });
        }
      } catch (error) {
        console.error("Error loading invoice data:", error);
        this.invoiceDialogData = [];
      }
    },

    handleItemUpdated(item) {
      console.log('Item updated:', item);
      
    },

    handleEditItem(item) {
      console.log('Edit item:', item);
      // Handle edit action - maybe open another dialog or form
    },

    handleItemDeleted(item) {
      console.log('Item deleted:', item);
      // Handle item deletion
    },

    async handleSaveChanges(data) {
      console.log('Saving changes:', data);
      
      try {
        // Save changes to your API
        for (const item of data.modified) {
          const param = {
            table: "task",
            statement: "update",
            type: "single",
            where: `id=${item.id}`,
            selector: "id",
            value: item.id,
            short: "false",
            extension: ""
          };

          await this.$func.queryAPI(param, item);
        }

        this.showSnackbar({
          message: 'Änderungen erfolgreich gespeichert!',
          color: 'success'
        });

        // Refresh the main list
        this.filterLoadData(this.search);
        
      } catch (error) {
        console.error("Error saving changes:", error);
        this.showSnackbar({
          message: 'Fehler beim Speichern der Änderungen',
          color: 'error'
        });
      }
    },

    handleExportData(data) {
      console.log('Exporting data:', data);
      
      // Convert to CSV or Excel format
      const csvData = data.map(item => ({
        'Abholdatum': item.pickup_timestamp,
        'Auftragsnummer': item.document_no,
        'Kunde': item.company,
        'Artikel': item.article_name,
        'Anzahl': item.pickup_qty,
        'Gesamt': item.price_total,
        'Rechnung': item.invoice
      }));

      // Use your existing CSV export functionality
      this.$refs.csvExporter.export(csvData);
    },

    handleDialogClose() {
      console.log('Dialog closed');
      this.showInvoiceDialog = false;
    },

    showSnackbar({ message, color }) {
      this.snackbar_title = message;
      this.snackbar_color = color;
      this.snackbar = true;
    },

    handleSearchClear() {
      console.log('search cleared via x button');
      localStorage.removeItem(this.getStorageKey());
      
      this.isUpdatingProgrammatically = true;

      this.search = '';

      this.data = [];

      this.$nextTick(() => {
        // Reset flag
        this.isUpdatingProgrammatically = false;
        
        // Now reload the data
        if (this.switch_clearing) {
          this.showNotClearedEntrys('');
        } else {
          this.filterLoadData('');
        }
      });
    },

    handleSearchInput() {
      if (this.search && this.search.trim() !== '') {
        localStorage.setItem(this.getStorageKey(), this.search);
      } else {
        localStorage.removeItem(this.getStorageKey());
      }
    },




    async getRatingValues(){


      // Einstellungen
      var param2 = {
        table: "parameter",
        statement: "custom",
        type: "",
        where: "false",
        selector: "",
        value: "",
        short: "false", // Übermittlung nur von id
        // filter: "false",
        // filterfield: "",
        // filtervalue: "",
        // operator: "true",
        // Filter noch hinzufügen
        extension: "SELECT schluessel, wert FROM parameter WHERE schluessel LIKE '%rating%' ORDER BY 'schluessel' ASC",
      }


      // Daten -> Werden nur bei Insert oder Update gesendet
      var data2 = {}

      var result2 = await this.$func.queryAPI(param2, data2)

      // console.log("result2")
      // console.log(result2)


      this.rating1 = result2[0]["wert"]
      this.rating2 = result2[1]["wert"]
      this.rating3 = result2[2]["wert"]
      this.rating4 = result2[3]["wert"]
      this.rating5 = result2[4]["wert"]

    },



    getStorageKey() {
    return `searchValue_${this.$route.path}`;
  },

  //  handleSearchClear() {
  //   console.log('search cleared via x button');
  //   localStorage.removeItem(this.getStorageKey());
  //   this.search = '';

  //   if (this.switch_clearing) {
  //     this.showNotClearedEntrys('');
  //   } else {
  //     this.filterLoadData('');
  //   }
  // },

  // handleSearchInput(event) {
  //   const value = event.target ? event.target.value : event;
  //   this.search = value;
  // },
    getComplaintRowClass(completed) {
     return completed == 1 ? 'row-green' : 'row-red';   
     },

    
    getRowClass(status) {
    switch (status) {
      case 'released':
        return 'row-green';
      case 'cancelled':
        return 'row-grey';
      case 'active':
        return 'row-red';
      default:
        return '';
    }
  },


    async selectEntry(id){
      console.log(id)
      this.$emit('add', id)
    },


async showNotClearedEntrys(searchTerm) {
    this.data = [];
    console.log("Running showNotClearedEntrys with search:", searchTerm);
    let extensionQuery = "(invoice IS NULL OR invoice='')";

    if (this.table == "task") {
        extensionQuery += " AND (pickup_date IS NOT NULL AND pickup_date<>'')";
    }

    // Add group type filter
    if (this.selected_group_type && this.selected_group_type.length > 0) {
        const groupTypeIds = this.selected_group_type.join(',');
        extensionQuery += ` AND group_type_id IN (${groupTypeIds})`;
    }

    if (searchTerm && searchTerm.trim() !== '') {
        let customerQuery = "";

        let i = 0;
        while (this.headers[i]) {
            if (this.headers[i].value !== "edit" &&
                this.headers[i].value !== "select" &&
                this.headers[i].value !== "select_add" &&
                this.headers[i].value !== "select_delete" &&
                this.headers[i].value !== "delete" &&
                this.headers[i].value !== "time" &&
                this.headers[i].value !== "typ") {
                customerQuery += this.headers[i].value + " LIKE '%" + searchTerm + "%' OR ";
            }
            i++;
        }

        if (this.table == "stock") {
            customerQuery += "date LIKE '%" + searchTerm + "%' OR ";
        }
        if (this.table == "task") {
            customerQuery += "pickup_date LIKE '%" + searchTerm + "%' OR ";
            customerQuery += "company LIKE '%" + searchTerm + "%' OR ";
            customerQuery += "document_no LIKE '%" + searchTerm + "%' OR ";
        }

        if (customerQuery) {
            customerQuery = customerQuery.substring(0, customerQuery.length - 4);
            extensionQuery += " AND (" + customerQuery + ")";
        }
    }

    let sort = "";
    if (this.default_sort) {
        sort = " ORDER BY " + this.default_sort + " " + this.default_sort_typ;
        if (this.table == "task") {
            sort = " ORDER BY pickup_timestamp " + this.default_sort_typ;
        }
    }

    // Final extension
    const extension = "WHERE " + extensionQuery + sort;
    console.log("Final query extension:", extension);

    // Einstellungen
    var param = {
        table: this.table,
        statement: "select",
        type: "list",
        where: "false",
        selector: "",
        value: "",
        short: "false", // Übermittlung nur von id
        debug: "false",
        extension: extension,
    };

    // Daten -> Werden nur bei Insert oder Update gesendet
    var data = {

    }

    var result = await this.$func.queryAPI(param, data);
    console.log("results count:", result.length);

    this.data = result;
},

async filterLoadData(search){
    console.log("filterLoadData", search);
    search = search !== undefined ? search : '';


    var extension = this.extension;
    var sort = " "
    if(this.default_sort != "" || this.sort != ""){
        if(this.sort != ""){
            sort = "ORDER BY `" + this.sort + "` " + this.default_sort_typ + " "
        }else{
            if(this.table == "stock"){
                sort = "ORDER BY `" + this.default_sort + "` " + this.default_sort_typ + ", time DESC " // Time
            }else{
                sort = "ORDER BY `" + this.default_sort + "` " + this.default_sort_typ + " ";
            }
        }
    }


    var limit = " "
    if(this.default_limit != ""){
        limit = "LIMIT " + this.default_limit
    }

    //  group type filter
    let groupTypeFilter = '';
    if (this.selected_group_type && this.selected_group_type.length > 0) {
        const groupTypeIds = this.selected_group_type.join(',');
        groupTypeFilter = `group_type_id IN (${groupTypeIds})`;
    }

    if (search != "") {
        var query = "";

        let i = 0;
        while (this.headers[i]) {
            if(this.headers[i].value != "edit" &&
                this.headers[i].value != "select" &&
                this.headers[i].value != "select_add" &&
                this.headers[i].value != "select_delete" &&
                this.headers[i].value != "delete" &&
                this.headers[i].value != "time" &&
                this.headers[i].value != "typ") {
                query = query + this.headers[i].value + " LIKE '%" + search + "%' OR ";
            }
            i++;
        }


        if (this.table == "stock") {
            query = query + "date" + " LIKE '%" + search + "%' OR ";
        }

        if (this.table == "task") {
            query = query + "pickup_date" + " LIKE '%" + search + "%' OR ";
            query = query + "company" + " LIKE '%" + search + "%' OR ";
            query = query + "document_no" + " LIKE '%" + search + "%' OR ";
        }

        query = query.substring(0, query.length - 4);

        
        let whereClause = '';
        if (extension == "") {
            whereClause = "WHERE ";
            if (groupTypeFilter) {
                whereClause += `(${groupTypeFilter}) AND (${query})`;
            } else {
                whereClause += `(${query})`;
            }
        } else {
            whereClause = "WHERE " + extension;
            if (groupTypeFilter) {
                whereClause += ` AND (${groupTypeFilter}) AND (${query})`;
            } else {
                whereClause += ` AND (${query})`;
            }
        }
        extension = whereClause + " " + sort + limit;

    } else {
        
        if (groupTypeFilter) {
            if (extension == "") {
                extension = `WHERE ${groupTypeFilter} ` + sort + limit;
            } else {
                extension = `WHERE ${extension} AND ${groupTypeFilter} ` + sort + limit;
            }
        } else {
            if (extension == "") {
                extension = sort + limit;
            } else {
                extension = "WHERE " + extension + " " + sort + limit;
            }
        }
    }

    //console.log("Final extension:", extension)
    this.data = []

    // Einstellungen
    var param = {
        table: this.table,
        statement: "select",
        type: "list",
        where: "false",
        selector: "",
        value: "",
        short: "false", // Übermittlung nur von id
        debug: "false",
          // filter: "false",
          // filterfield: "",
          // filtervalue: "",
          // operator: "true",
          // Filter noch hinzufügen
        extension: extension,
    }

    var data = {};

    var result = await this.$func.queryAPI(param, data);
    console.log("results count:", result.length);

    this.data = result;
},



    filterOnlyCapsText (value, search) {

      console.log("filter")

      return value != null &&
          search != null &&
          typeof value === 'string' &&
          value.toString().toLocaleUpperCase().indexOf(search.toString().toLocaleUpperCase()) !== -1
    },


    customSort(items, sortBy, sortDesc) {
      if (!sortBy.length) return items;

        const sortKey = sortBy[0];
        const direction = sortDesc[0] ? -1 : 1;

        const isDateColumn = ['date', 'execution_date', 'pickup_date',
                        'complaint_date', 'last_pickup'].includes(sortKey);

      return items.sort((a, b) => {
      if (isDateColumn) {
         const dateA = this.parseEuropeanDate(a[sortKey]);
         const dateB = this.parseEuropeanDate(b[sortKey]);
        if (isNaN(dateA) && isNaN(dateB)) return 0;
        if (isNaN(dateA)) return direction;
        if (isNaN(dateB)) return -direction;

        return direction * (dateA - dateB);
      }
    // For non-date columns, use standard comparison
      else {
        if (a[sortKey] === b[sortKey]) return 0;
        return direction * (a[sortKey] > b[sortKey] ? 1 : -1);
      }
     });
    },

parseEuropeanDate(dateStr) {
  if (!dateStr) return NaN;

  if (dateStr.includes('.')) {

    const [day, month, year] = dateStr.split('.');
    return new Date(year, month - 1, day);
  } else if (dateStr.includes('-')) {

    return new Date(dateStr);
  }

  return NaN;
},

    openAddView(){
      this.$router.push({ path: this.formview })
    },

    async deleteEntry() {
      if (this.dialog_password != localStorage.password_delete) {
        this.snackbar_title = "Password Falsch!"
        this.snackbar_color = "red"
        this.snackbar = true
        return
      }

      console.log('🗑️ Starting deletion process...');
      console.log('Table:', this.table);
      console.log('ID:', this.dialog_id);
      console.log('Text:', this.dialog_text);

      // ✅ Get the full record data BEFORE deleting
      let recordData = null;
      try {
        const selectParam = {
          table: this.table,
          statement: "select",
          type: "detail",
          where: "true",
          selector: "id",
          value: this.dialog_id,
          short: "false",
          extension: "",
        };

        const selectResult = await this.$func.queryAPI(selectParam, {});
        if (selectResult && selectResult.length > 0) {
          recordData = selectResult[0];
          console.log('✓ Retrieved record data before deletion:', recordData);
        }
      } catch (error) {
        console.error('Error retrieving record before deletion:', error);
      }

      // Einstellungen
      var param = {
        table: this.table,
        statement: "delete",
        type: "detail",
        where: "true",
        selector: "id",
        value: this.dialog_id,
        short: "true", // Übermittlung nur von id
        // filter: "false",
        // filterfield: "",
        // filtervalue: "",
        // operator: "true",
        // Filter noch hinzufügen
        extension: "",
      }

      // Daten -> Werden nur bei Insert oder Update gesendet
      var data = {
      }

      var result = await this.$func.queryAPI(param, data)

      console.log('Delete result:', result)

      if (result && result.status !== 'ERROR') {
        const { logActivity } = useActivityLog();
        
        try {
          await logActivity({
            action: 'DELETE',
            table_name: this.table,
            record_id: this.dialog_id,

            description: `record deleted`
          }, this.$func);
          
          console.log('✅ Activity logged successfully');
        } catch (logError) {
          console.error('❌ Failed to log activity:', logError);
        
        }
      }

      this.dialog = false

      if(this.table == "tour"){
        // Lösche Tour zuordnung
        await this.deleteMatchTour2Task(this.dialog_id)
      }


      this.filterLoadData(this.search)

      this.$emit('reload', '')


    },

    getTableDisplayName(tableName) {
      const tableNames = {
        'customer': 'Kunde',
        'task': 'Auftrag',
        'tour': 'Tour',
        'cis_user': 'CIS Account',
        'cis_task': 'CIS Auftrag',
        'stock': 'Lagerbestand',
        'disposal': 'Entsorgung',
        'transport': 'Transport',
        'driver': 'Fahrer'
      };
      return tableNames[tableName] || 'Eintrag';
    },
    async deleteMatchTour2Task(id){

      // Parameter
      var param = {
        table: "task",
        statement: "custom",
        type: "",
        where: "false",
        selector: "",
        value: "",
        short: "false", // Übermittlung nur von id
        // filter: "false",
        // filterfield: "",
        // filtervalue: "",
        // operator: "true",
        // Filter noch hinzufügen
        extension: "UPDATE task SET tour_id='',tour_notification_sent = 0 WHERE tour_id='" + id + "' AND pickup_date IS NULL",
      }

      // Data
      var data = {
      }

      await this.$func.queryAPI(param, data)
      // var result = await this.$func.queryAPI(param, data)
      // console.log(result)

    },





    async posUp(id){
      console.log("posUp")


      var currentPosition = await this.checkCurrentPosition(id)
      var numofposition = await this.checkNumofPosition()

      console.log("Aktuelle Position: " + currentPosition)
      console.log("ALLE Position: " + numofposition)

      if(currentPosition == 1){
        console.log("Bricht ab")
        return
      }

      await this.changePosition(Number(currentPosition) - 1, Number(currentPosition))
      await this.changePositionByID(id, Number(currentPosition) - 1)


      await this.filterLoadData(this.search)

      this.$emit('reload', '')

    },

    async posDown(id){
      console.log("posDown")

      var currentPosition = await this.checkCurrentPosition(id)
      var numofposition = await this.checkNumofPosition()

      console.log("Aktuelle Position: " + currentPosition)
      console.log("ALLE Position: " + numofposition)

      if(currentPosition == numofposition){
        console.log("Bricht ab")
        return
      }

      await this.changePosition(Number(currentPosition) + 1, Number(currentPosition))
      await this.changePositionByID(id, Number(currentPosition) + 1)

      await  this.filterLoadData(this.search)

      this.$emit('reload', '')

    },




    async resortPosition(){

      // Parameter
      var param = {
        table: 'task',
        statement: 'select',
        type: "list",
        where: "true",
        selector: "temp_tour_id",
        value: this.temp_tour_id,
        short: "true", // Übermittlung nur von id
        // filter: "false",
        // filterfield: "",
        // filtervalue: "",
        // operator: "true",
        // Filter noch hinzufügen
        extension: "ORDER BY `tour_position` ASC",
      }

      // Data
      var data = {
      }

      var result = await this.$func.queryAPI(param, data)

      if(result.length == 0){
        return
      }

      for (var i1 = 0; i1 < result.length; i1++) {
        await this.changePositionByID(result[i1]["id"], i1 + 1)
      }


      console.log(result)

    },

    async changePosition(pos_old, pos_new){

      // Parameter
      var param = {
        table: 'task',
        statement: 'update',
        type: "",
        where: "true",
        selector: "temp_tour_id",
        value: this.temp_tour_id,
        short: "true", // Übermittlung nur von id
        // filter: "false",
        // filterfield: "",
        // filtervalue: "",
        // operator: "true",
        // Filter noch hinzufügen
        extension: "AND tour_position='" + pos_old + "'",
      }

      // Data
      var data = {
        tour_position: pos_new,
      }

      var result = await this.$func.queryAPI(param, data)
      console.log(result)

    },

    async changePositionByID(id, pos_new){

      // Parameter
      var param = {
        table: 'task',
        statement: 'update',
        type: "",
        where: "true",
        selector: "id",
        value: id,
        short: "true", // Übermittlung nur von id
        // filter: "false",
        // filterfield: "",
        // filtervalue: "",
        // operator: "true",
        // Filter noch hinzufügen
        extension: "",
      }

      // Data
      var data = {
        tour_position: pos_new,
      }

      var result = await this.$func.queryAPI(param, data)
      console.log(result)

    },

  // Liefert Anzahl der Positionen
   async checkNumofPosition(){

      // Parameter
      var param = {
        table: 'task',
        statement: 'select',
        type: "detail",
        where: "true",
        selector: "temp_tour_id",
        value: this.temp_tour_id,
        short: "true", // Übermittlung nur von id
        // filter: "false",
        // filterfield: "",
        // filtervalue: "",
        // operator: "true",
        // Filter noch hinzufügen
        extension: "",
      }

       // Data
       var data = {
       }

       var result = await this.$func.queryAPI(param, data)
       console.log(result)

       return result.length ?? 0

    },

   async checkCurrentPosition(id){

      // Parameter
      var param = {
        table: 'task',
        statement: 'select',
        type: "detail",
        where: "true",
        selector: "id",
        value: id,
        short: "true", // Übermittlung nur von id
        // filter: "false",
        // filterfield: "",
        // filtervalue: "",
        // operator: "true",
        // Filter noch hinzufügen
        extension: "",
      }

      // Data
      var data = {
      }

      var result = await this.$func.queryAPI(param, data)
      console.log(result)

      return result[0]["tour_position"]

    },


  emitAddToTour(id) {
    this.$emit('add-to-tour', id)
  },

// async add2Tour(id) {
//   // Get the current max position first
//   const currentMaxPos = await this.checkNumofPosition();
//   const newPosition = Number(currentMaxPos) + 1;
  
//   // Parameter
//   var param = {
//     table: 'task',
//     statement: 'update',
//     type: "",
//     where: "true",
//     selector: "id",
//     value: id,
//     short: "true",
//     extension: "",
//   }

//   // Data
//   var data = {
//     temp_tour_id: this.temp_tour_id,
//     tour_position: newPosition
//   }

//   var result = await this.$func.queryAPI(param, data)
//   console.log(result)

//   await this.filterLoadData(this.search)

//   // Löst ein Reload aus ggf. andere List
//   this.$emit('reload', '')
// },

   async delete2Tour(id){

      // Parameter
      var param = {
        table: 'task',
        statement: 'update',
        type: "",
        where: "true",
        selector: "id",
        value: id,
        short: "true", // Übermittlung nur von id
        // filter: "false",
        // filterfield: "",
        // filtervalue: "",
        // operator: "true",
        // Filter noch hinzufügen
        extension: "",
      }


      // Data
      var data = {
        temp_tour_id: "",
        tour_id: "",
      }

      var result = await this.$func.queryAPI(param, data)
      console.log(result)

      await this.resortPosition()

      await this.filterLoadData(this.search)

      // Löst ein Reload aus ggf. andere List
      this.$emit('reload', '')


    },

    showDeleteDialog(id, text){
      this.dialog_id = id
      this.dialog_text = text
      this.dialog = true
    },

    editEntry(id){

      this.$router.push({ path: this.formview + "/" + id, params:{id: id} })

    },

    async loadData(){

      this.data = []

      // Einstellungen
      var param = {
        table: this.table,
        statement: "select",
        type: "list",
        where: "false",
        selector: "",
        value: "",
        short: "false", // Übermittlung nur von id
        debug: "false",
        // filter: "false",
        // filterfield: "",
        // filtervalue: "",
        // operator: "true",
        // Filter noch hinzufügen
        extension: this.extension,
      }

      // Daten -> Werden nur bei Insert oder Update gesendet
      var data = {
      }

      var result = await this.$func.queryAPI(param, data)
      console.log(this.extension)



      this.data = result

    },

  

  },

  props: {

    headers: Array,
    formview: String,
    table: String,
    extension: String,



    height: {
      default: "",
      type: String
    },


    default_limit: {
      default: "",
      type: String
    },

    default_sort: {
      default: "",
      type: String
    },

    default_sort_typ: {
      default: "DESC",
      type: String
    },

    filter_clearing: {
      default: false,
      type: Boolean
    },

    export_csv: {
      default: false,
      type: Boolean
    },


    addbutton: {
      default: true,
      type: Boolean
    },


    temp_tour_id: String,



  }
 


}
</script>

<style>
.row-green {
  background-color: rgba(0, 128, 0, 0.3) !important;
}
.row-grey {
  background-color: #e0e0e0 !important; 
}
.row-red {
  background-color: #f8d7da !important; 
}
</style>


